var registerPrimitive = require('../primitives').registerPrimitive;

registerPrimitive('a-collada-model', {
  mappings: {
    src: 'collada-model'
  }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/aframe/src/extras/primitives/primitives/a-collada-model.js
// module id = 2063
// module chunks = 0